import HeroSection from "../../Components/HeroSection";
import HowItWorksSection from "../../Components/HowItWorksSection";
import WhatMakesShyftBootCampUniqueSection from "../../Components/WhatMakesShyftBootCampUniqueSection";
import CallbackSection from "../../Components/CallbackSection";
import Testimonials from "@/components/Organisms/TestimonialsV2";
import RealWorldTransformation from "../../Components/RealWorldTransformation";
import AppBannerSection from "../../Components/AppBannerSection";
import BootcampListing from "../../Components/BootcampListing";
import AllPackagesSection from "../../Components/AllPackagesSection";
import ReadyToBuildSection from "../../Components/ReadyToBuildSection";
import FaqSection from "@/components/Molecules/FaqSection";
import FloatingBanner from "../../Components/FloatingBanner";
import BookSlotModal from "../../Components/BookSlotModal";
import BookTrialClassForm from "../../Components/BookTrialClassForm";
import BookTrialClassModal from "../../Components/BookTrialClassModal";
import CustomIntercomButton from "../../Components/CustomIntercomButton";

import CertifiedInstructors from "../../Components/Shared/CertifiedInstructors";

import { classNameGenerator } from "@/utils";

import { useAppSelector } from "@/hooks";

import styles from "./NutritionDietPlanPage.module.scss";

interface NutritionDietPlanPageProps {}

const NutritionDietPlanPage: React.FC<NutritionDietPlanPageProps> = () => {
  const cls = classNameGenerator(styles);

  const { data } = useAppSelector((state) => state.bootCamp);

  const { testimonies } = data?.testimonials || {};
  const faqs = data?.faqs || {};

  return (
    <div className={cls("nutritionDietPlanPage")}>
      <HeroSection />
      <HowItWorksSection>
        <BookTrialClassForm />
      </HowItWorksSection>
      <WhatMakesShyftBootCampUniqueSection />
      <Testimonials testimonies={testimonies} />
      <CallbackSection />
      <RealWorldTransformation />
      <AllPackagesSection />
      <BookTrialClassForm standalone />
      <AppBannerSection />
      <div className={cls("certifiedInstructors")}>
        <CertifiedInstructors />
      </div>
      <BootcampListing />
      <FaqSection {...faqs} />
      <ReadyToBuildSection />
      <FloatingBanner />
      <BookSlotModal title={data?.bookSlotForm?.title} />
      <BookTrialClassModal />
      {/* <CustomIntercomButton /> */}
    </div>
  );
};

export default NutritionDietPlanPage;
